import { inject } from 'vue';

export const useWinTab = () => {
    return inject('__win_tab__', {
        closeCurrentTab: () => {},
        closeOtherTabs: () => {},
        closeAllTabs: () => {},
    });
};
